// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".comment-error{max-width:700px}.comment-error .comment-msg{padding-left:15px}.commentActionCol{display:inline-block}.deleteCommentText{color:#666}", ""]);
// Exports
module.exports = exports;
